/// <amd-module name="VSSUI/Components/Card/CardFooter" />
import * as React from "react";
import { ICardFooterProps } from "./Card.Props";

import { SurfaceContext } from "VSSUI/Surface";
import { css } from "VSSUI/Util";

export const CardFooter: React.SFC<ICardFooterProps> = props => {
    return (
        <SurfaceContext.Consumer>
            {surfaceContext => (
                <div className={css(props.className, "bolt-card-footer flex-row flex-noshrink", surfaceContext.horizontalClassName)}>
                    {props.children}
                </div>
            )}
        </SurfaceContext.Consumer>
    );
};
